import { ExternalBlog } from 'src/types';

const BlogStyleArticle: React.FC<{ externalBlog: ExternalBlog }> = ({ externalBlog }) => {
  return externalBlog.bodyHtml ? (
    <div
      className="normal-article js-blog-body"
      dangerouslySetInnerHTML={{ __html: externalBlog.bodyHtml }}
    ></div>
  ) : (
    <></>
  );
};

export default BlogStyleArticle;
